import axios, { AxiosError } from "axios"
import toast from "react-hot-toast"
import { IResponseGeneratorUserSettingsAddUserResponse, IUserSettingsAddUserBody } from "../../../../interface/interfaces";
import React from "react";
import { saveUserSettingsToken } from "../userSettingsSaveUserTokenToDB.slice";
import { useAppDispatch } from "../../../../redux/hooks";

export const saveUserToDb = async (
    setSaveUserToDbLoading: React.Dispatch<React.SetStateAction<boolean>>,
    value: IUserSettingsAddUserBody,
    dispatch: ReturnType<typeof useAppDispatch>
)=>{
    setSaveUserToDbLoading(true);
    
    try{
        // console.log('process.env.REACT_APP_USER_SETTINGS_API}/users: ', `${process.env.REACT_APP_USER_SETTINGS_API}/users`)
        const fetchSaveUserToDB = (await axios.post(`${process.env.REACT_APP_USER_SETTINGS_API}/users`, value, {
            headers: {
                'Content-Type': 'application/json',
            },
        })) as IResponseGeneratorUserSettingsAddUserResponse;
        
        const savedUserToDBData = fetchSaveUserToDB.data;
        dispatch(saveUserSettingsToken(savedUserToDBData.output.token));

        toast.success(
            <p>
                {savedUserToDBData.output.text}
            </p>
        );

        setSaveUserToDbLoading(false);
    }catch(err){
        if(err instanceof AxiosError){
            toast.error(`Save user to db failed. ${err.message}`)
        } else {
            toast.error('Something went wrong with saving user to db.');
        }
    } finally{
        setSaveUserToDbLoading(false);
    }
}